import React from "react";
import { defineMessages, useIntl } from "react-intl";

const ErrorState = () => {
    const intl = useIntl();
    return <p>{intl.formatMessage(messages.error)}</p>;
};
export default ErrorState;

const messages = defineMessages({
    error: {
        id: "workshop-queryError",
        defaultMessage: "Cannot retrieve data",
    },
});
